// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__29Kgj","description":"PatientConsentPreview_description__xK2U_"};